// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  name: 'test',
  production: false,
  firebaseRoot: '/test',
  // apiBaseUrl: 'http://192.168.0.224:8000/1.0',
  apiBaseUrl: 'https://us-central1-cinomatch.cloudfunctions.net'
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/environments/environment.ts